/**
 * Load the vehicle stock once and index it by id.
 *
 * Deals need the linked vehicle's driveaway price to show a real value
 * instead of an estimate. Fetching one vehicle per card would mean N
 * requests on every board render, so we pull the list once and map it.
 */
import { useEffect, useState } from 'react';
import { vehiclesService } from './services';

const unwrapList = (r) =>
  r?.data?.content
  ?? r?.content
  ?? (Array.isArray(r?.data) ? r.data : null)
  ?? (Array.isArray(r) ? r : []);

export function useVehicleMap({ size = 200 } = {}) {
  const [byId, setById] = useState(() => new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    vehiclesService.list({ page: 0, size })
      .then((res) => {
        if (cancelled) return;
        const rows = unwrapList(res);
        setById(new Map(rows.filter(v => v?.id).map(v => [v.id, v])));
      })
      .catch(() => { /* deals fall back to estimated values */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [size]);

  return { vehiclesById: byId, loadingVehicles: loading };
}

export default useVehicleMap;
